var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('AppleBackdropExp',{attrs:{"readyOn":_vm.tab('detail')}}),_c('ProPricingExp'),_c('AppleQualityTvExp',{attrs:{"readyOn":_vm.tab('detail')}}),_c('BypassUCTExp',{attrs:{"readyOn":_vm.tab('detail')}}),_c('CrunchyrollAsiaFreeTrialExp',{attrs:{"readyOn":_vm.tab('detail')}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }